import { useEffect, useState } from 'react';
import placeholder from './placeholder.jpg';

function useLoadedImage(image) {
  const [cover, setCover] = useState(placeholder);

  useEffect(() => {
    if (!image) {
      return;
    }
    const imgElement = new Image();
    imgElement.src = image;

    imgElement.addEventListener('load', () => {
      setCover(image);
    });
  }, [image]);

  return { image: cover, isLoaded: !image || cover === image };
}

export default useLoadedImage;
